import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";

// Define the payload for the Inventory Projection SOQ Table API
// Define the payload for the Inventory Projection SOQ Table API
export interface IInventoryProjectionPayload {
    dc: string[];
    storeNumber: string[];
    category: string[];
    subCategory: string[];
    productSegm: string[];
    uCode: string[];
    productDesc: string[];
    itemId: string[];
    fcwNumber: string[];
    vendorName: string[];
}

// Define the payload for the Forecast Overview DropDown Filter API
export interface IForecastFilterPayload {
    dc: string[];
    storeNumber: string[];
    category: string[];
    subCategory: string[];
    productSegm: string[];
    productDesc: string[];
    ucode: string[];
    itemId: string[];
    fcwNumber: string[];
    vendorName: string[];
    modeType: string[];
    adType: string[];
}

// Define the API slice
export const inventoryProjectionApi = createApi({
    reducerPath: "inventoryProjectionApi",
    baseQuery: axiosBaseQuery(),
    endpoints: (builder) => ({
        // Mutation: Get Inventory Projection SOQ Data
        getInventoryProjectionSOQ: builder.mutation({
            query: (payload: IInventoryProjectionPayload) => ({
                url: "/inventoryProjectionSOQTable",
                method: "POST",
                data: payload,
            }),
        }),

        // Mutation: Get Forecast Overview DropDown Filter Data
        getForecastOverviewDropDownFilter: builder.mutation({
            query: (payload: IForecastFilterPayload) => ({
                url: "/forecastOverViewDropDownFilter",
                method: "POST",
                data: payload,
            }),
        }),
        getInventoryProjectionSOQLineChart: builder.mutation({
            query: (payload: IForecastFilterPayload) => ({
                url: "/inventoryProjectionSOQLineChart",
                method: "POST",
                data: payload,
            }),
        }),
    }),
});

export const {
    useGetInventoryProjectionSOQMutation,
    useGetForecastOverviewDropDownFilterMutation,
    useGetInventoryProjectionSOQLineChartMutation,
} = inventoryProjectionApi;
